/**
 * Whether a role may issue gift cards at a company. Mirrors the backend gate
 * (gift-card.controller.ts) and is fail-CLOSED: admin always passes, every
 * other role needs an explicit `giftCardWriteAccess` grant. Deliberately not
 * the company store's fail-open `selectIsPermitted`, which showed this button
 * to every role at an unconfigured company and 403'd on every click.
 */
export function hasGiftCardWriteAccess(role, permissions) {
  if (!role) return false
  if (role === 'admin') return true
  return !!permissions?.giftCardWriteAccess?.includes(role)
}
